import { render } from "./CaretDown.vue?vue&type=template&id=54e101b2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CaretDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54e101b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54e101b2', __exports__)) {
    api.reload('54e101b2', __exports__)
  }
  
  module.hot.accept("./CaretDown.vue?vue&type=template&id=54e101b2", () => {
    api.rerender('54e101b2', render)
  })

}


export default __exports__